export const PRISE_WITH_SUBSCRIPTION_FILTERS = {
  0: '0-4.000 kr.',
  1: '4.000-6.000 kr.',
  2: '6.000-8.000 kr.',
  3: '8.000 kr.'
}
